import React from "react";
import { cn } from "@/lib/utils";

// Schweizer Flagge als Inline-SVG — rendert überall identisch (Emoji-Flaggen
// erscheinen auf Windows nur als "CH"-Buchstaben).
export const SwissFlag = ({ className }) => (
  <svg viewBox="0 0 32 32" className={cn("h-3.5 w-3.5 rounded-[3px] shrink-0", className)} aria-hidden="true">
    <rect width="32" height="32" fill="#DA291C" rx="5" />
    <rect x="13.5" y="6.5" width="5" height="19" fill="#fff" />
    <rect x="6.5" y="13.5" width="19" height="5" fill="#fff" />
  </svg>
);

export default function SwissBadge({ variant = "light", compact = false, className }) {
  return (
    <span
      data-testid="swiss-badge"
      title="Made in Switzerland"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] select-none whitespace-nowrap",
        variant === "dark"
          ? "border-white/25 bg-white/10 text-white/90 backdrop-blur-sm"
          : "border-zinc-200 bg-white text-zinc-500",
        className
      )}
    >
      <SwissFlag />
      {!compact && <span>Made in Switzerland</span>}
    </span>
  );
}
